import React from "react";
import { Link } from "react-router-dom";
import { BaseButtonTypes } from "./types";

const BaseButton: React.FC<BaseButtonTypes> = ({
	onClick,
	text,
	fontFamily,
	fontColor,
	fontSize,
	shape,
	buttonSize,
	bgColor,
	borderColor,
	iconOrder,
	icon,
	iconBreakpoint,
	textBreakpoint,
	textAdditionalClasses,
	disabledButtonClasses,
	additionalClasses,
	type = "button",
	to,
	href,
	tooltip,
	isDisabled = false,
	as: Element = "a",
	hoverBackground,
	hoverUnderline,
	hoverBorderColor,
	hoverFontColor,
	iconAriaLabel,
	iconClasses,
	ariaSelected,
	buttonType,
	dataTestId,
	...props
}) => {
	let buttonClasses = `flex justify-center ${
		iconOrder === "last" ? "flex-row-reverse" : ""
	} items-center ${shape} ${buttonSize} ${additionalClasses} ${
		isDisabled
			? `cursor-not-allowed ${disabledButtonClasses}`
			: `cursor-pointer ${borderColor} ${bgColor} ${hoverBackground} ${hoverBorderColor}`
	}`;
	const textClasses = `${fontFamily} ${fontSize} ${textBreakpoint} ${textAdditionalClasses} ${fontColor} ${hoverFontColor}`;
	const iconClassNames = `${iconClasses} ${iconBreakpoint}  `;

	const handleClick = (
		e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
	) => {
		if (isDisabled) {
			e.preventDefault();
			return;
		}
		onClick?.(e);
	};

	const baseProps = {
		className: buttonClasses,
		onClick: handleClick,
		type: type,
		"aria-disabled": isDisabled ? "true" : "false",
		"data-tooltip": tooltip,
		"aria-label": iconAriaLabel,
		"aria-selected": ariaSelected,
		...(dataTestId ? { "data-testid": dataTestId } : {}),
	};

	if (Element === "a") {
		props = { ...baseProps, href: href };
	} else if (Element === "link") {
		Element = Link;
		props = { ...baseProps, to: to };
	} else if (Element === "button") {
		props = { ...baseProps };
	}

	return (
		<Element {...props}>
			{icon && <span className={iconClassNames}>{icon}</span>}
			<div className={textClasses}> {text}</div>
		</Element>
	);
};

export default BaseButton;
